// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as ViewCampaign from "./sidebar-screens/view-campaign/ViewCampaign.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CreateCampaignContainer from "./sidebar-screens/create-campaign/CreateCampaignContainer.bs.js";
import * as ManagePrioritiesContainer from "./sidebar-screens/manage-priorities/ManagePrioritiesContainer.bs.js";
import * as CreateMandatoryCampaignCmp from "./sidebar-screens/create-campaign/CreateMandatoryCampaignCmp.bs.js";
import * as CreateZonalOrClusterAllocationCampaignCmp from "./sidebar-screens/create-campaign/CreateZonalOrClusterAllocationCampaignCmp.bs.js";

function getMandatoryCampaign(campaigns_list) {
  var mandatory_campaign = List.filter(function (campaign) {
          return campaign.campaign_status === /* Active */0;
        })(campaigns_list.campaigns);
  var match = List.length(mandatory_campaign);
  if (match !== 0) {
    if (match !== 1) {
      return ErrorUtils$Catalyst.raiseError("AllocationDashboardSidebarCmp.res", "More than one mandatory campaign found", "");
    } else {
      return Belt_List.getExn(mandatory_campaign, 0);
    }
  } else {
    return ErrorUtils$Catalyst.raiseError("AllocationDashboardSidebarCmp.res", "No mandatory campaign found", "");
  }
}

function AllocationDashboardSidebarCmp(Props) {
  var vehicle = Props.vehicle;
  var geo_region = Props.geo_region;
  var zones = Props.zones;
  var clusters = Props.clusters;
  var sidebar = Props.sidebar;
  var campaigns_list = Props.campaigns_list;
  var user_role = Props.user_role;
  var zone_cluster_campaigns_list = Props.zone_cluster_campaigns_list;
  var dispatch = Props.dispatch;
  var setDirty = Props.setDirty;
  if (typeof sidebar !== "number") {
    return React.createElement(ViewCampaign.make, {
                campaign: sidebar.campaign,
                user_role: user_role,
                campaigns_list: campaigns_list,
                dispatch: dispatch
              });
  }
  switch (sidebar) {
    case /* CreateCampaignContainer */0 :
        return React.createElement(CreateCampaignContainer.make, {
                    vehicle: vehicle,
                    geo_region: geo_region,
                    campaigns_list: campaigns_list,
                    dispatch: dispatch
                  });
    case /* CreateMandatoryCampaign */1 :
        return React.createElement(CreateMandatoryCampaignCmp.make, {
                    vehicle: vehicle,
                    geo_region: geo_region,
                    campaigns_list: campaigns_list,
                    dispatch: dispatch
                  });
    case /* CreateZonalOrClusterCampaign */2 :
        return React.createElement(CreateZonalOrClusterAllocationCampaignCmp.make, {
                    vehicle: vehicle,
                    geo_region: geo_region,
                    campaigns_list: campaigns_list,
                    zones: zones,
                    clusters: clusters,
                    dispatch: dispatch,
                    zone_cluster_campaigns_list: zone_cluster_campaigns_list
                  });
    case /* ManagePriorities */3 :
        return React.createElement(ManagePrioritiesContainer.make, {
                    mandatory_campaign: getMandatoryCampaign(campaigns_list),
                    vehicle: vehicle,
                    geo_region: geo_region,
                    zones: zones,
                    clusters: clusters,
                    zone_cluster_campaigns_list: zone_cluster_campaigns_list,
                    dispatch: dispatch,
                    user_role: user_role,
                    setDirty: setDirty
                  });
    
  }
}

var make = AllocationDashboardSidebarCmp;

export {
  getMandatoryCampaign ,
  make ,
  
}
/* react Not a pure module */
